import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const CHAIN_META = {
  eth: { name: "Ethereum", color: "#627EEA", short: "ETH" },
  base: { name: "Base", color: "#0052FF", short: "BASE" },
  arb: { name: "Arbitrum", color: "#28A0F0", short: "ARB" },
  op: { name: "Optimism", color: "#FF0420", short: "OP" },
  polygon: { name: "Polygon", color: "#8247E5", short: "POLY" },
  bsc: { name: "BSC", color: "#F3BA2F", short: "BSC" },
  avax: { name: "Avalanche", color: "#E84142", short: "AVAX" },
  sol: { name: "Solana", color: "#14F195", short: "SOL" },
};

export const CHAINS = Object.entries(CHAIN_META).map(([id, m]) => ({ id, ...m }));

export const fmtUSD = (n) => {
  const v = Number(n || 0);
  if (v >= 1_000_000) return `$${(v / 1_000_000).toFixed(2)}M`;
  if (v >= 1_000) return `$${(v / 1_000).toFixed(2)}k`;
  return `$${v.toFixed(2)}`;
};

export const shortAddr = (a) => {
  if (!a) return "";
  if (a.length <= 12) return a;
  return `${a.slice(0, 6)}…${a.slice(-4)}`;
};
